<template>
  <div />
</template>

<script>
  export default {
    name: "Features",
    mounted() {
      this.$router.replace({ name: this.pub.routeNameLists.HomePage, params: { initiativeGuide: 'yes' }})
    }
  }
</script>

<style scoped>

</style>
